import { render, staticRenderFns } from "./cvInforReview.vue?vue&type=template&id=1cdc7ad1&scoped=true"
import script from "./cvInforReview.vue?vue&type=script&lang=js"
export * from "./cvInforReview.vue?vue&type=script&lang=js"
import style0 from "./cvInforReview.vue?vue&type=style&index=0&id=1cdc7ad1&prod&scoped=true&lang=css"
import style1 from "./cvInforReview.vue?vue&type=style&index=1&id=1cdc7ad1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc7ad1",
  null
  
)

export default component.exports